/*
 * @Author: 孙培国
 * @Date: 2024-08-17 16:47:30
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-01-24 18:05:17
 * @FilePath: \new-adminproject-frontend-h5\src\config\env.staging.js
 */
// 本地环境配置
module.exports = {
  title: '赛事',
  englishName:'H5 Template System',
  version: 'V1.0.0',
  technicalSupport: '',
  copyright: 'Copyright @ 2023  ',
  // baseUrl: 'https://wz.zhenkelife.com/api', // 项目地址.
  baseUrl: 'https://wz.zhenkelife.com', // 项目地址
  baseApi: '/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  corpId: '钉钉id'
}
